import React from 'react';
import { Link } from 'react-router-dom'

import './components.css';

import Carousel from 'react-bootstrap/Carousel';

import imagemCarrocel1 from '../../img/img1.jpg'
import imagemCarrocel2 from '../../img/img2.jpg'
import imagemCarrocel3 from '../../img/img3.jpg'

const Carrocel = () => {

  return (

    <div className='carrocel'>

      <Carousel>
        <Carousel.Item interval={5000}>
          <img className="d-block w-100" src={imagemCarrocel1} alt="" />
          <Carousel.Caption>

          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item interval={5000}>
          <img className="d-block w-100" src={imagemCarrocel2} alt="" />
          <Carousel.Caption>

          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item interval={5000}>
          <img className="d-block w-100" src={imagemCarrocel3} alt="" />
          <Carousel.Caption>

          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>

    </div>
  )

}



export default Carrocel;


































/* 
import React from "react";

function Footer(){

var ano = new Date().getFullYear();

return <section id="footer">
<div>
       <ul className="list-unstyled list-inline social text-center">
           <li className="list-inline-item"><a href="#"><i className="fa fa-facebook fa-2x"></i></a></li>
           <li className="list-inline-item"><a href="#"><i className="fa fa-twitter fa-2x"></i></a></li>
           <li className="list-inline-item"><a href="#"><i className="fa fa-instagram fa-2x"></i></a></li>
           <li className="list-inline-item"><a href="#" target="_blank"><i classNameName="fa fa-envelope fa-2x"></i></a></li>
       </ul>
</div>

        <a href="Santa Mônica Centro Educacional"></a>
        <p>Santa Mônica Centro Educacional - {ano} </p>
        <span>(21) 97029-4268 / (21) 2491-5800</span>
        </section>;
        

}

export default Footer;

*/